import React, { FC } from 'react';

import { Box, Button, Typography } from '@mui/material';

import { styles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { getFile } from '@bus/storyTeller/selectors';
import { getValidToken, removeQuotes } from '@REST/api';
import { storyTellerActions } from '@bus/storyTeller/actions';
import { handleErrors } from '@helpers/handleErrors';

type ErrorStateProps = {
  currentChatId: number;
};

export const ErrorState: FC<ErrorStateProps> = ({ currentChatId }) => {
  const dispatch = useDispatch();
  const file = useSelector(getFile);
  const handleClick = async () => {
    if (file) {
      const tokenAccess = await getValidToken();
      dispatch(storyTellerActions.setIsFileLoading(true));

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/storytellers/upload-story/`,
          {
            method: 'POST',
            body: file,
            headers: {
              Authorization: 'Bearer ' + removeQuotes(tokenAccess!),
            },
          },
        );

        if (response.ok) {
          dispatch(storyTellerActions.setIsFileLoading(true));
        }
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  return (
    <Box sx={styles.errorState}>
      <Typography
        width={'100%'}
        variant={'body1'}
        mb={'20px'}
        textAlign={'center'}>
        Something went wrong
      </Typography>
      <Button variant={'primary'} color={'sixth'} onClick={handleClick}>
        <Typography variant={'body1'}>Try again</Typography>
      </Button>
    </Box>
  );
};

export default ErrorState;
